import { render, staticRenderFns } from "./ChatSystemBox.vue?vue&type=template&id=4d3f8096&scoped=true"
import script from "./ChatSystemBox.vue?vue&type=script&lang=js"
export * from "./ChatSystemBox.vue?vue&type=script&lang=js"
import style0 from "./ChatSystemBox.vue?vue&type=style&index=0&id=4d3f8096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f8096",
  null
  
)

export default component.exports